module.exports = __webpack_public_path__ + "img/mapper-processed.f9fb97e.png";